export default "__VITE_ASSET__CJs_bAgo__"